<template>
  <div class="bg_blue">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/indexpc' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 人才库申报</el-breadcrumb-item>
      </el-breadcrumb>
      <el-alert title="温馨提示" type="error" class="elalert">
        1.请先登陆个人会员帐号或注册（注意只对个人会员，单位会员无法报名）<br />
        2.请您确保在整个申报流程中，您所填写的信息属实。<br />
      </el-alert>

      <div class="left_and_right_container">
        <div class="container_center">
          <el-form
            :model="formData"
            ref="ruleForm"
            :rules="rules"
            label-width="200px"
            class="demo-ruleForm"
          >
            <div class="apply_info_title">申报信息</div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="省市县" prop="areas">
                  <el-cascader
                    v-model="formData.areas"
                    :options="areaOptions"
                    :props="{ label: 'title' }"
                    class="inputSizeClass"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="学校名称" prop="danwei">
                  <el-input
                    type="text"
                    placeholder="请输入学校名称"
                    v-model="formData.danwei"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="姓名" prop="ldname">
                  <el-input
                    type="text"
                    placeholder="请输入姓名"
                    v-model="formData.ldname"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="身份证号" prop="num">
                  <el-input
                    type="text"
                    placeholder="请输入身份证号"
                    v-model="formData.num"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="联系手机" prop="phone">
                  <el-input
                    type="text"
                    placeholder="请输入手机"
                    v-model="formData.phone"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="已取得演员级别" prop="grade">
                  <el-select
                    v-model="formData.grade"
                    placeholder="请选择"
                    class="inputSizeClass"
                  >
                    <el-option
                      v-for="item in gradeOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="上传照片" prop="pics">
                  <PicUploader
                    :fileList="formData.pics"
                    :limit="1"
                    :name="'pics'"
                  ></PicUploader>

                  <span class="el-note">请上传1张2寸照片</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="个人才艺" prop="caiyi">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 4 }"
                    placeholder="请输入个人才艺"
                    v-model="formData.caiyi"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="false">
              <el-form
                :rules="userListForm.rules"
                :model="userListForm"
                ref="userListForm"
              >
                <el-table :data="userListForm.list" style="width: 100%">
                  <el-table-column prop="name" label="姓名" width="180">
                    <template slot-scope="scope">
                      <p v-if="!scope.row.edit">
                        {{ scope.row.name }}
                      </p>
                      <p v-else>
                        <el-form-item
                          :prop="'list.' + scope.$index + '.name'"
                          :rules="userListForm.rules.name"
                        >
                          <el-input
                            v-model="scope.row.name"
                            placeholder="请输入姓名"
                          />
                        </el-form-item>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="num" label="身份证" width="180">
                    <template slot-scope="scope">
                      <p v-if="!scope.row.edit">
                        {{ scope.row.num }}
                      </p>
                      <p v-else>
                        <el-form-item
                          :prop="'list.' + scope.$index + '.num'"
                          :rules="userListForm.rules.num"
                        >
                          <el-input
                            v-model="scope.row.num"
                            placeholder="请输入身份证号"
                          />
                        </el-form-item>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sex" label="性别">
                    <template slot-scope="scope">
                      <p v-if="!scope.row.edit">
                        {{ scope.row.sex }}
                      </p>
                      <p v-else>
                        <el-form-item
                          :prop="'list.' + scope.$index + '.sex'"
                          :rules="userListForm.rules.sex"
                        >
                          <el-select
                            v-model="scope.row.sex"
                            placeholder="请选择"
                          >
                            <el-option label="男" value="男"> </el-option>
                            <el-option label="女" value="女"> </el-option>
                          </el-select>
                        </el-form-item>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="phone" label="手机">
                    <template slot-scope="scope">
                      <p v-if="!scope.row.edit">
                        {{ scope.row.phone }}
                      </p>
                      <p v-else>
                        <el-form-item
                          :prop="'list.' + scope.$index + '.phone'"
                          :rules="userListForm.rules.phone"
                        >
                          <el-input
                            v-model="scope.row.phone"
                            placeholder="请输入手机号"
                          />
                        </el-form-item>
                      </p>
                    </template>
                  </el-table-column>

                  <el-table-column prop="sex" label="服务套餐">
                    <template slot-scope="scope">
                      <p v-if="!scope.row.edit">
                        {{ scope.row.service_name }} ({{
                          scope.row.service_price
                        }}元)
                      </p>
                      <p v-else>
                        <el-form-item
                          :prop="'list.' + scope.$index + '.service_id'"
                          :rules="userListForm.rules.service_id"
                        >
                          <el-select
                            v-model="scope.row.service_id"
                            @change="onServiceChange($event, scope.row)"
                            placeholder="请选择"
                          >
                            <el-option
                              :key="sindex"
                              v-for="(service, sindex) in service_options"
                              :label="
                                service.name + '(' + service.price + '元)'
                              "
                              :value="service.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="action" label="操作">
                    <template slot-scope="scope">
                      <p v-if="!scope.row.edit">
                        <el-button @click="onUserEdit(scope.row)"
                          >编辑</el-button
                        >
                        <el-popconfirm
                          title="这是一段内容确定删除吗？"
                          @confirm="onUserRemove(scope.row, scope.$index)"
                        >
                          <el-button slot="reference">删除</el-button>
                        </el-popconfirm>
                      </p>
                      <p v-else>
                        <el-button @click="onUserSave(scope.row)"
                          >保存</el-button
                        >
                        <el-popconfirm
                          title="这是一段内容确定删除吗？"
                          @confirm="onUserRemove(scope.row, scope.$index)"
                        >
                          <el-button slot="reference">删除</el-button>
                        </el-popconfirm>
                      </p>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form>
              <div style="margin-top: 20px">
                <el-button @click="onUserAdd()">新增用户</el-button>
              </div>
            </el-row>

            <el-row>
              <el-col class="btn_position_class">
                <el-button type="primary" @click="ensureSubmit()"
                  >提交</el-button
                >
                <el-button @click="resetForm('ruleForm')" plain>重置</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <ElPayDialog
      :show="payDialogShow"
      scene="rencaiku"
      :ids="orderIds"
      @onPayError="onPayError"
      @onPaySuccess="onPaySuccess"
      @onPayClose="onPayClose"
    />
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="50%"
      center
    >
      <span>申报信息一旦提交成功后，不可修改！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">返回修改</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import validator from "../../../utils/validator";
import NewsListItem from "@/components/listItem/NewsListItem";
import ElPayDialog from "@/components/ElPayDialog";
import PicUploader from "@/components/picker/PicUploader";
import { CountDown } from "vant";

Vue.use(CountDown);

export default {
  name: "CmsDetail",
  data() {
    return {
      centerDialogVisible: false,

      areaOptions: [],
      payDialogShow: false,
      orderIds: [],
      type: 4,
      rules: {
        areas: [{ required: true, message: "请选择省市县", trigger: "blur" }],
        danwei: [
          { required: true, message: "请输入学校名称", trigger: "blur" },
        ],
        grade: [{ required: true, message: "请选择等级", trigger: "blur" }],
        pics: [{ required: true, message: "请上传图片", trigger: "blur" }],
        ldname: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
        num: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: validator.idCard, trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validator.phone, trigger: "blur" },
        ],
      },
      formData: {
        id: 0,
        saiqu_name: "",
        danwei: "",
        phone: "",
        note: "",
        ldname: "",
        areas: [],
        pics: [],
        get_date: null,
        extra_course_id: "",
        grade: "",
      },
      userListForm: {
        rules: {
          sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
          service_id: [
            { required: true, message: "请选择套餐", trigger: "blur" },
          ],
          name: [
            { required: true, message: "请输入姓名", trigger: "blur" },
            {
              min: 2,
              max: 20,
              message: "长度在 2 到 50 个字符",
              trigger: "blur",
            },
          ],
          num: [
            { required: true, message: "请输入身份证号", trigger: "blur" },
            { validator: validator.idCard, trigger: "blur" },
          ],
          phone: [
            { required: true, message: "请输入手机号", trigger: "blur" },
            { validator: validator.phone, trigger: "blur" },
          ],
        },
        list: [],
      },
      gradeOptions: [
        {
          id: 1,
          name: "一级",
        },
        {
          id: 2,
          name: "二级",
        },
        {
          id: 3,
          name: "三级",
        },
        {
          id: 4,
          name: "四级",
        },
        {
          id: 5,
          name: "五级",
        },
        {
          id: 6,
          name: "六级",
        },
        {
          id: 7,
          name: "七级",
        },
        {
          id: 8,
          name: "八级",
        },
      ],
      row: {
        id: 0,
        current_index: 0,
        question_list: [],
        user: {},
        kaoji: {},
      },
      courseOptions: [],
      service_options: [],
    };
  },
  components: {
    NewsListItem,
    ElPayDialog,
    PicUploader,
  },
  computed: {},
  mounted() {
    let that = this;
    that.formData.id = this.$route.query.id || 0;
    this.fetch();
    // document.title = "联系人信息";
    that.getAreaOptions();
  },
  methods: {
    ensureSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.centerDialogVisible = true;
        } else {
          //有必填项  未 填写
        }
      });
    },
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (r) => {
        that.areaOptions = r.data;
      });
    },
    getGradeOptions() {
      let that = this;
      that.$api.post(
        "/api/kaoji/extraCourseOptions",
        {
          grade: that.formData.grade,
        },
        (r) => {
          that.courseOptions = r.data;
        }
      );
    },
    onGradeChange() {
      let that = this;
      that.formData.extra_course_id = "";
      that.getGradeOptions();
    },
    onServiceChange(val, row) {
      let selected = this.service_options.filter((item) => {
        return item.id == val;
      });
      if (selected.length == 0) {
        return;
      }
      row.service_name = selected[0].name;
      row.service_price = selected[0].price;
    },
    fetch() {
      let that = this;
      that.$api.get(
        "/api/rencaiku/step1Detail",
        {
          type: that.type,
          id: that.formData.id,
        },
        (res) => {
          setTimeout(() => {
            if (res.data.area) {
              res.data.areas = [
                res.data.area.substring(0, 2) + "0000",
                res.data.area.substring(0, 4) + "00",
                res.data.area,
              ];
            } else {
              res.data.areas = [];
            }
          }, 500);
          // if(that.formData.id){
          that.formData = res.data;
          // }

          // that.formData = Object.assign(that.formData, res.data);
          that.service_options = res.data.service_options;
          that.userListForm.list = res.data.member_list.map((member) => {
            that.$set(member, "edit", false);
            return member;
          });

          console.log("Dialog");
          if (res.data.haveNoDone) {
            Dialog.setDefaultOptions({
              confirmButtonText: "继续未完成的报名",
              cancelButtonText: "重新报名",
            });
            Dialog.confirm({
              title: "您有未完成的报名",
              message: "建议您选择继续未完成的报名",
            })
              .then(() => {
                that.jumToOld();
              })
              .catch(() => {});
          }
        },
        (res) => {
          console.log("没有登录");
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            that.$message.error(res.msg);
          }
        }
      );
    },
    onUserAdd() {
      let that = this;
      that.userListForm.list.push({
        name: "",
        phone: "",
        sex: "",
        num: "",
        service_id: "",
        edit: true,
      });
    },
    onUserSave(row) {
      const that = this;
      that.$refs["userListForm"].validate((valid) => {
        if (valid) {
          row.edit = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onUserEdit(row) {
      row.edit = true;
    },
    onUserRemove(row, index) {
      this.userListForm.list.splice(index, 1);
    },
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.formData.areas.length != 3) {
            that.$message.error("请选择省市");
            return;
          }
          that.formData["area"] = that.formData.areas[2];

          that.formData.list = JSON.stringify(that.userListForm.list);
          // that.formData.get_date = that.formData.get_date_m.format('YYYY-MM-DD');
          that.$api.post("/api/rencaiku/baoming", that.formData, (r) => {
            that.$message.success("保存成功");
            that.$router.push({ name: "rencaikuApplyList", query: {} });

            // that.formData.id = r.data.id;
            // if(r.data.memberstatus != 1){
            //   that.$api.post("/api/rencaiku/ordersave",{
            //     id: that.formData.id
            //   },(r2) =>{
            //     that.orderIds = r2.data.ids;
            //     that.payDialogShow = true;
            //   },(r2) =>{
            //     that.$message.error(r.msg);
            //   });
            // }

            // that.$router.push({name:'KaojiExame',query:{
            //   kaoji_id:r.data.id
            //   }})
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    onPayError() {
      let that = this;
      console.log("onPayError 支付失败");
      that.payDialogShow = false;

      that.$toast("支付失败");

      rbLink(
        {
          name: "rencaikuApplyList",
        },
        "replace"
      );
    },
    onPaySuccess() {
      let that = this;
      console.log("onPaySuccess 支付成功");
      that.payDialogShow = false;

      appEvent({
        name: "saiApplyDetailReload",
        query: {},
      });

      setTimeout(function () {
        rbLink(
          {
            name: "rencaikuApplyList",
            query: {},
          },
          "replace"
        );
      }, 500);
    },
    onPayClose() {
      let that = this;
      console.log("onPayClose 支付关闭");
      that.payDialogShow = false;

      setTimeout(function () {
        rbLink(
          {
            name: "rencaikuApplyList",
          },
          "replace"
        );
      }, 500);
    },
  },
};
</script>
<style scoped lang="scss">
.apply_info_title {
  font-size: 20px;
  font-weight: bold;
}
.status-1 {
  background: #559f07;
  color: #fff;
}
.status-2 {
  background: #e02020;
  color: #fff;
}
.status-0 {
  background: #f4faff;
  color: #666666;
}
.bg_blue {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  min-height: 1235px;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.elalert {
  margin: 0 0 40px 0;
}
.elsteps {
  margin: 0 0 25px 0;
}
.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .container_left {
    width: 212px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    .container_left_content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 88px 0 0 0;
      .container_left_content_img {
        width: 108px;
        height: 108px;
        border-radius: 8px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          border: none;
          object-fit: cover;
        }
      }
      .container_left_content_name {
        margin: 16px 0;
        height: 20px;
        font-size: 14px;

        font-weight: 500;
        color: #333333;
        line-height: 20px;
        span {
          color: #666666;
        }
      }
      .container_left_content_serve {
        display: flex;
        align-items: center;
        line-height: 17px;
        font-size: 12px;

        font-weight: 400;
        color: #0091ff;
        .el-icon-service {
          margin: 0 9px 0 0;
          font-size: 17px;
        }
        &:hover {
          cursor: default;
          font-weight: bold;
        }
      }
    }
  }
  .container_center {
    width: 1240px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    padding-top: 24px;
    padding: 88px 0 0 29px;
    box-sizing: border-box;
    .inputSizeClass {
      width: 240px;
      height: 40px;
      border-radius: 4px;
    }
    .btn_position_class {
      text-align: center;
      margin: 42px 0 0 0;
      box-sizing: border-box;
      /deep/.el-button {
        width: 139px;
        height: 44px;
        border-radius: 22px;
        font-size: 14px;
      }
    }
  }

  .container_right {
    width: 296px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
  }
}
</style>


// WEBPACK FOOTER //
// RencaikuApplyStep41.vue?7dccaac8